// extracted by mini-css-extract-plugin
module.exports = {"form":"signin_form__ucnte"};